module.exports = __webpack_public_path__ + "img/mobile-list.2120f34e.svg";